import { motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { BRAND } from "./data";
import { useContent } from "./ContentContext";
import { useTx } from "./siteText";

export const OrderFab = () => {
  const { settings } = useContent();
  const tx = useTx();
  if (settings.orderFab?.enabled === false) return null;
  const label = tx("nav.orderLabel").text || "Order Online";

  return (
    <motion.a
      href={BRAND.orderUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="order-fab"
      initial={{ opacity: 0, y: 40, scale: 0.8 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ delay: 1.4, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.95 }}
      className="fixed z-[60] flex items-center gap-2.5 rounded-full bg-cantina-marigold text-cantina-cocoa font-sans font-bold tracking-wide px-5 py-3.5 md:px-6 md:py-4"
      style={{
        bottom: "calc(1.1rem + env(safe-area-inset-bottom, 0px))",
        right: "calc(1.1rem + env(safe-area-inset-right, 0px))",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      {/* pulsing halo */}
      <motion.span
        aria-hidden
        className="absolute inset-0 rounded-full bg-cantina-marigold"
        style={{ zIndex: -1 }}
        animate={{ scale: [1, 1.35, 1], opacity: [0.45, 0, 0.45] }}
        transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
      />
      {/* glow breathing */}
      <motion.span
        aria-hidden
        className="absolute inset-0 rounded-full"
        style={{ zIndex: -1 }}
        animate={{
          boxShadow: [
            "0 8px 24px rgba(242,182,50,0.35)",
            "0 10px 44px rgba(242,182,50,0.75)",
            "0 8px 24px rgba(242,182,50,0.35)",
          ],
        }}
        transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.span
        animate={{ rotate: [0, -12, 12, -8, 0] }}
        transition={{ duration: 2.6, repeat: Infinity, ease: "easeInOut", repeatDelay: 1.2 }}
        className="flex items-center"
      >
        <ShoppingBag size={18} strokeWidth={2.4} />
      </motion.span>
      <span className="text-sm md:text-base whitespace-nowrap">{label}</span>
    </motion.a>
  );
};
